import React from "react"
import autobind from "class-autobind"
import Dialog from "material-ui/Dialog"
import TextField from "material-ui/TextField"
import FlatButton from "material-ui/FlatButton"
import strings from "../../localization/strings"
import Clear from "../../components/misc/Clear"
import { Toggle } from "material-ui"
import CircularProgress from "material-ui/CircularProgress"
import Table from "../common/Table"
import { TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
import AccountStore from "../../stores/AccountStore"
import ImageLoader from "../misc/ImageLoader"
import AuthenticationStore from "../../stores/AuthenticationStore"
import * as permissionHelper from "../../helpers/permissionHelper"
import * as api from "../../api"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import { IUIUser } from "../../models"
import { debounce } from "lodash"
interface IProps {
	open: boolean
	filterByLevel: boolean
	jobId?: string
	singleSelectable?: boolean
	handleClose(): void
	handleAddEmployees(employees: IUIUser[]): void
}
interface IState {
	employeeList: IUIUser[]
	search: string
	offset: number
	loading: boolean
	total: number
	selectedEmployees: IUIUser[]
	jobId: string
}

export default class AddEmployeeDialogForChip extends React.Component<IProps, IState>  {
	private limit: number
	constructor(props) {
		super(props)
		this.state = {
			employeeList: [],
			search: "",
			offset: 0,
			loading: false,
			total: 0,
			selectedEmployees: [],
			jobId: "",
		}
		autobind(this)
		const tempLimit = Math.floor(window.innerHeight / 50) - 9
		this.limit = tempLimit > 8 ? 8 : tempLimit
	}

	componentDidMount() {
		this.getEmployeeList()
	}

	getEmployeeList() {
		this.setState({ loading: true }, () => {
			const { offset, search } = this.state
			const accountId = AccountStore.getCurrentAccount().Id
			const levelId = this.props.filterByLevel ? HierarchySettingsStore.getGlobalLevelItemFilterId() : ""
			api.getUIUsers(
				accountId,
				offset / this.limit,
				this.limit,
				search,
				levelId,
				true,
				AccountStore.getSupervisorDirectReportEnabled() && !permissionHelper.hasPermission(AuthenticationStore.Permissions.SupervisorDirectReport.ViewAllEmployees),
				false,
				this.state.jobId
			).then(res =>
				this.setState({
					employeeList: res.data.Documents,
					total: res.data.TotalDocumentCount,
					loading: false
				})
			)
		})
	}

	handleSearch = debounce(() => this.getEmployeeList(), 1000)

	render() {
		const actions = [
			<FlatButton
				data-intercom-target={"Employee-Btn-CloseEmployeeSelectionDialog"}
				key="cancel"
				label={strings.Cancel}
				secondary
				onClick={this.props.handleClose}
			/>,
			<FlatButton
				data-intercom-target={"Employee-Btn-SaveSelectedEmployee"}
				key="ok"
				label={strings.OK}
				primary
				keyboardFocused
				disabled={!this.state.selectedEmployees || !this.state.selectedEmployees.length}
				onClick={() => this.props.handleAddEmployees(this.state.selectedEmployees)}
			/>
		]
		const tableHeaders = ["Name", "Employee_ID", "Punch_Hierarchy", "Default_Hierarchy"]

		return (
			<Dialog
				title={strings.Choose_Employee}
				actions={actions}
				modal={true}
				open={this.props.open}
				onRequestClose={this.props.handleClose}
			>
				{AccountStore.getCRMEnabled() && this.props.jobId &&
					<Toggle
						data-intercom-target={"ChooseEmployee-Toggle-FilterOnlyWorkerPool"}
						onToggle={(e, checked) =>
							this.setState({ jobId: checked ? this.props.jobId : "" }, () => {
								this.getEmployeeList()
							})
						}
						style={{ width: 220, float: "right" }}
						defaultToggled={false}
						label={strings.Filter_Only_Worker_Pool}
					/>
				}
				<div style={{ padding: 20, paddingLeft: 35 }}>
					<i style={{ fontSize: 25 }} className="fa fa-search" />
					<TextField
						data-intercom-target={"ChooseEmployee-Entry-Search"}
						style={{ marginRight: 20, width: "90%", marginLeft: 15 }}
						hintText={strings.search}
						value={this.state.search}
						onChange={e => {
							this.setState({
								search: e.target.value,
								offset: 0,
								loading: true,
								selectedEmployees: []
							})
							this.handleSearch()
						}}
					/>
					<Clear />
				</div>
				<div style={{ textAlign: "center", height: 500 }}>
					{this.state.loading ?
						<CircularProgress /> :
						<Table
							singleSelectable={this.props.singleSelectable}
							items={this.state.employeeList}
							selectedItems={this.state.selectedEmployees}
							handleSelect={selectedEmployees => this.setState({ selectedEmployees })}
							total={this.state.total}
							offset={this.state.offset}
							limit={this.limit}
							onPageClick={offset => this.setState({ offset, selectedEmployees: [] }, () => this.getEmployeeList())}
						>
							<TableHeader>
								<TableRow>
									<TableHeaderColumn style={{ width: 30, textAlign: "center" }} />
									{tableHeaders.map((header, i) =>
										<TableHeaderColumn key={`header-equipmentTable-${header}`} className="TextOverflow" title={strings[header]} style={{ textAlign: "center" }}>
											{strings[header]}
										</TableHeaderColumn>
									)}
								</TableRow>
							</TableHeader>
							<TableBody showRowHover={true} deselectOnClickaway={false}>
								{this.state.employeeList.map((row, i) => {
									let smallImage
									if (row.ProfileImageS3Url || row.ProfileImageID) {
										smallImage = (
											<ImageLoader url={row.ProfileImageS3Url} fixedHeight={75} avatar={true} src={"/users/profileimage/" + row.ProfileImageS3Url} key={`smallImg-${i}`} />
										)
									}
									// For long names, display tooltip (title)
									let titleName = row.FirstName + " " + row.LastName
									if (titleName.length < 25) {
										titleName = ""
									}
									const defaultHierarchy = hierarchyHelper.getFullyQualifiedLevelNameById(row.DefaultHierarchyItemId)
									const defaultPunchHierarchy = hierarchyHelper.getFullyQualifiedLevelNameById(row.DefaultPunchHierarchyId)
									return (
										<TableRow
											data-intercom-target={`ChooseEmployeeTable-SelectEmployee${i}`}
											key={row.Id}
											selected={this.state.selectedEmployees.find(i => i.Id === row.Id) ? true : false}
										>
											<TableRowColumn style={{ width: 30, textAlign: "center" }}>{smallImage}</TableRowColumn>
											<TableRowColumn style={{ textAlign: "center", cursor: "pointer" }} title={titleName}>
												{row.FirstName + " " + row.LastName}
											</TableRowColumn>
											<TableRowColumn style={{ textAlign: "center", cursor: "pointer" }}>{row.ExternalId}</TableRowColumn>
											<TableRowColumn style={{ textAlign: "center", cursor: "pointer" }} title={defaultHierarchy}>
												{defaultHierarchy}
											</TableRowColumn>
											<TableRowColumn style={{ textAlign: "center", cursor: "pointer" }} title={defaultPunchHierarchy}>
												{defaultPunchHierarchy}
											</TableRowColumn>
										</TableRow>
									)
								})}
							</TableBody>
						</Table>
					}
				</div>
			</Dialog >
		)
	}
}